import Util from '../../../forecast-app/shared/util/util';
import SendQuoteReplyMutation from '../../../mutations/send_quote_reply_mutation';

/** Mirrors the server-side cap and the column the message is stored in. */
export const MAX_REPLY_LENGTH = 5000;

export type QuoteReplyInput = {
	quoteId: string;
	clientContactId: string;
	message: string;
};

/**
 * Emails the reply. Always via Util.CommitMutation — never react-relay's commitMutation — so the
 * correlation-ID error modal and the logged-out handling still apply.
 *
 * The first argument must be a mutation MODULE exposing commit(), not a graphql tag:
 * Util.CommitMutation calls mutationClass.commit(), and the module is also what supplies the CSRF
 * token and socket client id the backend requires.
 */
export function sendQuoteReply(input: QuoteReplyInput, onSuccess: () => void, onError?: () => void): void {
	Util.CommitMutation(
		SendQuoteReplyMutation,
		input,
		onSuccess,
		// retry=false, deliberately — same reasoning as sendQuote. A reply is append-only: every
		// accepted call emails the contact and writes an activity row, so Util.CommitMutation's
		// automatic 500ms retry after a lost RESPONSE would send the reply twice while the user
		// sees one success.
		false,
		null,
		(transaction: unknown, onFailure: (t: unknown) => unknown) => {
			// Always fall through to the framework handler, or the readable rejection warning modal
			// (and its correlation id) is swallowed. It answers true only when it has scheduled a
			// retry of this mutation; with retry disabled above it never can, but the guard stays
			// so re-enabling retry cannot silently re-arm the composer mid-flight.
			const retryScheduled = onFailure(transaction);
			if (retryScheduled !== true && onError) onError();
		}
	);
}
